import cx from 'classnames';

import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';

import EmailIconWrapper from '../Base/EmailIconWrapper';
import EmailInput from '../Base/EmailInput';
import InputWrapper from '../Base/InputWrapper';
import SubmitButton from '../Base/SubmitButton';
import type { TemplateProps } from '../types';

const Template3 = ({ signupStyles, isSubmitting, autoFocus, setEmail, onEmailChange }: TemplateProps) => {
  const { classes } = useWebThemeContext();

  const {
    fontFamily,
    buttonFontFamily,
    buttonBgColor,
    buttonTextColor,
    placeholderBgColor,
    placeholderTextColor,
    buttonText,
    placeholderText,
    borderEnabled,
    borderColor,
    emailIconEnabled,
  } = signupStyles;

  return (
    <InputWrapper className="gap-2 overflow-hidden">
      <EmailIconWrapper
        color={buttonBgColor}
        iconEnabled={emailIconEnabled}
        className={cx(classes.radius)}
        style={{
          backgroundColor: placeholderBgColor,
          border: borderEnabled ? `2px solid ${borderColor}` : 'none',
        }}
      >
        <EmailInput
          fontFamily={fontFamily}
          autoFocus={autoFocus}
          setEmail={setEmail}
          onEmailChange={onEmailChange}
          placeholderText={placeholderText}
          textColor={placeholderTextColor}
          className="py-3"
        />
      </EmailIconWrapper>

      <div
        className={cx('w-full sm:w-auto', classes.radius)}
        style={{
          backgroundColor: borderEnabled ? buttonBgColor : '',
          border: borderEnabled ? `2px solid ${buttonBgColor}` : 'none',
        }}
      >
        <SubmitButton
          isSubmitting={isSubmitting}
          fontFamily={buttonFontFamily}
          ctaText={buttonText}
          backgroundColor={buttonBgColor}
          textColor={buttonTextColor}
        />
      </div>
    </InputWrapper>
  );
};

export default Template3;
